import React from "react";
import { Space } from "antd";
import EditHomeHealthcareButton from "./EditHomeHealthcareButton";

const ActionsColumn = ({
  columnData,
  allCountry,
  countryCode,
  onUpdateVendorEquipment,
  getSingleHealthcareVendor,
  onUpdateHomeHealthcareOwner,
  updateHealthcareVendor,
  props,
}) => (
  <Space>
    <EditHomeHealthcareButton
      columnData={columnData}
      countryCode={countryCode}
      allCountry={allCountry}
      onUpdateVendorEquipment={onUpdateVendorEquipment}
      getSingleHealthcareVendor={getSingleHealthcareVendor}
      onUpdateHomeHealthcareOwner={onUpdateHomeHealthcareOwner}
      updateHealthcareVendor={updateHealthcareVendor}
      props={props}
    />
  </Space>
);
export default ActionsColumn;
